import { render } from "./ProxyPlayHistory.vue?vue&type=template&id=bb1ce736&scoped=true"
import script from "./ProxyPlayHistory.vue?vue&type=script&lang=js"
export * from "./ProxyPlayHistory.vue?vue&type=script&lang=js"

import "./ProxyPlayHistory.vue?vue&type=style&index=0&id=bb1ce736&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb1ce736"]])

export default __exports__